<div class="layout-wrapper" [ngClass]="containerClass">
  <app-confirm-dialog></app-confirm-dialog>
  <app-topbar></app-topbar>
  <app-sidebar></app-sidebar>
  <div class="layout-main-container">
    <div class="layout-main">
      <router-outlet></router-outlet>
    </div>
    <app-footer></app-footer>
  </div>
  <div class="layout-mask animate-fadein"></div>
</div>

<app-alerta
  [title]="alerta.title$ | async"
  [message]="alerta.message$ | async"
  [show]="alerta.show$ | async"
  [type]="alerta.type$ | async"
  [decision]="alerta.decision$ | async"
  (onConfirm)="alerta.confirm()"
  (onCancel)="alerta.cancel()"
></app-alerta>

<app-loading
  [show]="loading.show$ | async"
  [texto]="loading.texto$ | async"
></app-loading>